/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EnterpriseCustomerIdDto } from './enterpriseCustomerIdDto';
import { LocationSettingsDto } from './locationSettingsDto';
import { LocationGeometryDto } from './locationGeometryDto';
import { ExaAdapterIdDto } from './exaAdapterIdDto';
import { EnterpriseIdDto } from './enterpriseIdDto';

export interface LocationV2Dto { 
    id?: number;
    deleted?: boolean;
    active?: boolean;
    updated?: string;
    name?: string;
    type?: string;
    comment?: string;
    color?: string;
    customer?: EnterpriseCustomerIdDto;
    owner?: EnterpriseIdDto;
    identifier?: string;
    externalId?: string;
    geometry?: LocationGeometryDto;
    validFrom?: string;
    validUntil?: string;
    arrivalLoopSeparator?: boolean;
    settings?: LocationSettingsDto;
    pairedAdapter?: ExaAdapterIdDto;
    lastOnline?: string;
    fmisRefId?: string;
}
